"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _I18n = _interopRequireDefault(require("I18n"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _UIDropdown = _interopRequireDefault(require("./UIDropdown"));

var _UITypeahead = _interopRequireDefault(require("../typeahead/UITypeahead"));

var _ButtonConstants = require("../button/ButtonConstants");

var _lazyEval = _interopRequireDefault(require("../utils/lazyEval"));

var _createLazyPropType = _interopRequireDefault(require("../utils/propTypes/createLazyPropType"));

var _OptionTypes = require("../types/OptionTypes");

var UIDropdownSelect = _react.default.createClass({
  displayName: "UIDropdownSelect",
  propTypes: {
    buttonClassName: _propTypes.default.string,
    buttonUse: _propTypes.default.oneOf(Object.keys(_ButtonConstants.USE_CLASSES)).isRequired,
    onChange: _propTypes.default.func,
    onSearchChange: _propTypes.default.func,
    options: _propTypes.default.arrayOf(_OptionTypes.OptionType).isRequired,
    placeholder: (0, _createLazyPropType.default)(_propTypes.default.string).isRequired,
    searchable: _propTypes.default.bool.isRequired,
    value: _OptionTypes.SingleValueType
  },
  getDefaultProps: function getDefaultProps() {
    return {
      buttonClassName: 'p-x-2',
      buttonUse: 'transparent',
      placeholder: function placeholder() {
        return _I18n.default.text('salesUI.UIDropdownSelect.placeholder');
      },
      searchable: false
    };
  },
  getButtonText: function getButtonText(_ref, _ref2) {
    var placeholder = _ref.placeholder;
    var selectedOption = _ref2.selectedOption;
    return selectedOption ? selectedOption.text : (0, _lazyEval.default)(placeholder);
  },
  renderDropdownContent: function renderDropdownContent(_ref3) {
    var onChange = _ref3.onChange,
        options = _ref3.options,
        searchable = _ref3.searchable,
        onSearchChange = _ref3.onSearchChange;
    return _react.default.createElement(_UITypeahead.default, {
      resultsClassName: "p-y-0" // the default padding is redundant in a UIDropdown
      ,
      minimumSearchCount: searchable ? 0 : Infinity,
      onChange: onChange,
      onSearchChange: onSearchChange,
      options: options
    });
  },
  render: function render() {
    var _this$props = this.props,
        onChange = _this$props.onChange,
        options = _this$props.options,
        placeholder = _this$props.placeholder,
        searchable = _this$props.searchable,
        onSearchChange = _this$props.onSearchChange,
        value = _this$props.value,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["onChange", "options", "placeholder", "searchable", "onSearchChange", "value"]);
    var selectedOption;
    options.forEach(function (option) {
      if (option.value === value && !selectedOption) {
        selectedOption = option;
      }

      if (option.options) {
        _devLogger.default.warn({
          message: 'UIDropdownSelect: The given `options` include groups, which are not supported. ' + 'Use `UISelect` instead.',
          key: 'UIDropdownSelect-groups',
          url: 'https://git.hubteam.com/HubSpot/UIComponents/issues/6467'
        });
      }
    });
    return _react.default.createElement(_UIDropdown.default, (0, _extends2.default)({}, rest, {
      buttonText: this.getButtonText({
        placeholder: placeholder
      }, {
        selectedOption: selectedOption
      })
    }), this.renderDropdownContent({
      onChange: onChange,
      options: options,
      searchable: searchable,
      onSearchChange: onSearchChange
    }));
  }
});

var _default = (0, _Controllable.default)(UIDropdownSelect, ['open', 'value']);

exports.default = _default;
module.exports = exports.default;